import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class EarthPressuresModelIntervalModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (EarthPressuresModelIntervalModel._instance == null) EarthPressuresModelIntervalModel._instance = new EarthPressuresModelIntervalModel(authManager);
        return EarthPressuresModelIntervalModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'earth-pressures/earth-pressures-model-intervals');

        this.entityName = 'earth-pressures.EarthPressuresModelInterval';
        this.privileges = {
            create: [["adminSystem"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminSystem"]],
            delete: [["adminSystem"]],
        };

        this.label = 'Ps Model Interval';
        this.setLabel = 'Ps Model Intervals';

        this.browser = {
            name: 'default-earth-pressures-earthpressuresmodelinterval-browser',
            moduleName: 'default-earth-pressures-earthpressuresmodelinterval-browser',
            moduleTitle: 'Ps Model Intervals',
            moduleStateSlotName: 'default-earth-pressures-earthpressuresmodelinterval-browser',
        };

        this.editor = {
            name: 'default-earth-pressures-earthpressuresmodelinterval-editor',
            moduleName: 'default-earth-pressures-earthpressuresmodelinterval-editor',
            moduleTitle: 'Ps Model Interval',
            moduleStateSlotName: 'default-earth-pressures-earthpressuresmodelinterval-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'calculationId',
                type: 'EarthPressuresCalculation',
                persistent: true,
                label: 'Calculation',
            },
            {
                name: 'modelIntervalId',
                type: 'ModelInterval',
                persistent: true,
                label: 'Model Interval',
                description: 'reference to particular ps model interval',
                required: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: false,
                label: 'Model Section',
                description: 'only for info (check)',
                readOnly: true,
            },
            {
                name: 'isWithinWaterBody',
                type: 'bool',
                persistent: false,
                label: 'Is Within Water Body',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyId',
                type: 'WaterBody',
                persistent: false,
                label: 'Water Body',
                description: 'reference to particular water body',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'waterBodyTypeId',
                type: 'WaterBodyType',
                persistent: false,
                label: 'Water Body Type',
                description: 'reference to particular water body type',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'waterUnitWeightGamaW',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Water Unit Weight Gama W',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'geoTypeId',
                type: 'GeoType',
                persistent: false,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'bulkUnitWeightGama',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Bulk Unit Weight Gama',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'dryUnitWeightGamaD',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Dry Unit Weight Gama D',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'saturatedUnitWeightGamaSat',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Saturated Unit Weight Gama Sat',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'degreeOfSaturationSr',
                type: 'float',
                persistent: false,
                unit: '1',
                label: 'Degree Of Saturation Sr',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'moistureContentW',
                type: 'float',
                persistent: false,
                unit: '%',
                label: 'Moisture Content W',
                description: 'Moisture (Water) Content Chosen Value',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'soilUnitWeightGamaCalcMethodId',
                type: 'SoilUnitWeightGamaCalculationMethod',
                persistent: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'soilUnitWeightGama',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
